module.exports = __webpack_public_path__ + "static/media/img_34.0c7abc18.png";